import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlaystation5Component } from './simple-icons-playstation5.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlaystation5Component ],
    exports:      [ SimpleIconsPlaystation5Component ],
    bootstrap:    []
})
export class SimpleIconsPlaystation5Module {}
